import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import MyModal from '../../../../components/Modal';

interface ISearchByRegistrationModal {
  searchByRegistrationModalShow: boolean;
  setSearchByRegistrationModalShow: Dispatch<SetStateAction<boolean>>;
  searchByRegistration: (registration: string) => Promise<void>;
}

export default function SearchByRegistrationModal({
  searchByRegistrationModalShow,
  setSearchByRegistrationModalShow,
  searchByRegistration,
}: ISearchByRegistrationModal) {
  const [registration, setRegistration] = useState<string>('');

  function handleRegistrationChange(event: ChangeEvent<HTMLInputElement>) {
    setRegistration(event.target.value);
  }

  const isValidToSearchByRegistration = !!registration;

  return (
    <MyModal
      show={searchByRegistrationModalShow}
      title={'Pesquisar por Matrícula'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByRegistrationModalShow(false)}
      onAction={() => searchByRegistration(registration)}
      isActionButtonDisabled={!isValidToSearchByRegistration}
      type="action"
      size='lg'
      modalBody={(
        <FormGroup>
          <label htmlFor="contactName">Digite a Matrícula do usuário</label>
          <Input
            value={registration}
            onChange={handleRegistrationChange}
            placeholder="Matrícula do usuário"
          />
        </FormGroup>
      )}
    />
  );
}
